import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';
import api from './api';

const FCM_TOKEN_STORAGE_KEY = 'fcm_token';

export async function initWebPushNotifications() {
  try {
    const supported = await isSupported().catch(() => false);
    if (!supported) return { enabled: false, reason: 'unsupported' };

    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
      return { enabled: false, reason: 'missing_browser_apis' };
    }

    const cfgRes = await api.get('/firebase/web-config');
    const firebaseConfig = cfgRes?.data?.data?.firebaseConfig;
    const vapidKey = cfgRes?.data?.data?.vapidKey;

    if (!firebaseConfig?.apiKey || !vapidKey) {
      return { enabled: false, reason: 'missing_server_config' };
    }

    // Must be on the web app origin root.
    await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return { enabled: false, reason: 'permission_denied' };
    }

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    const token = await getToken(messaging, { vapidKey });
    if (!token) return { enabled: false, reason: 'no_token' };

    const prev = localStorage.getItem(FCM_TOKEN_STORAGE_KEY);
    if (prev !== token) {
      await api.post('/firebase/token', { newtoken: token });
      localStorage.setItem(FCM_TOKEN_STORAGE_KEY, token);
    }

    // Foreground handler (optional; app can also show its own in-app UI)
    onMessage(messaging, () => {});

    return { enabled: true, token };
  } catch (error) {
    return { enabled: false, reason: 'error', error };
  }
}

